import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import JogoDosPaus from "./JogoDosPaus";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <JogoDosPaus />
  </React.StrictMode>
);
